import { getMinActionLogsRetentionSimpleDate, isWithinActionLogRetentionPeriod } from 'automation-ui-management/constants/DataRetention';
import { CUSTOM_PRESET_ID } from 'automation-ui-management/constants/DateRangePickerOptions';
import { getHistoryFiltersFromDateRange } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { getDateRangeRequestFilters, makeDateRangeFromParsedSearchString } from 'automation-ui-management/utils/dateRangeUtils';
export const transformSearchParamsForEnrollmentHistory = searchParams => {
  searchParams.delete('startTimestamp');
  searchParams.delete('endTimestamp');
  return searchParams.toString();
};
export const transformSearchParamsForTroubleshootEnrollment = searchParams => {
  var _searchParams$get;
  const startDate = searchParams.get('startDate');
  const endDate = searchParams.get('endDate');
  const rangeType = (_searchParams$get = searchParams.get('rangeType')) !== null && _searchParams$get !== void 0 ? _searchParams$get : undefined;
  const dateRange = makeDateRangeFromParsedSearchString({
    rangeType,
    startDate,
    endDate
  });
  const {
    startTimestamp,
    endTimestamp
  } = getDateRangeRequestFilters(dateRange);
  if (startTimestamp) searchParams.set('startTimestamp', String(startTimestamp));
  if (endTimestamp) searchParams.set('endTimestamp', String(endTimestamp));
  return searchParams.toString();
};
export const getDefaultDateRangeWithMinRetentionDate = dateRange => {
  const startDate = dateRange.startDate;
  const defaultDateRange = {
    presetId: CUSTOM_PRESET_ID,
    startDate: startDate && isWithinActionLogRetentionPeriod(startDate) ? startDate : getMinActionLogsRetentionSimpleDate()
  };
  return getHistoryFiltersFromDateRange(defaultDateRange);
};